import {Store, Module, ActionContext} from 'vuex';
import ListModule from './list-module';
import ListState from './list-state';
import AwardWinUser from '../entities/awardwinuser';
import Ajax from '../../lib/ajax';
import PageResult from '@/store/entities/page-result';

interface AwardWinUserState extends ListState<AwardWinUser> {
    editAwardWinUser: AwardWinUser;
}
class AwardWinUserModule extends ListModule<AwardWinUserState, any, AwardWinUser> {
    public state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<AwardWinUser>(),
        loading: false,
        editAwardWinUser: new AwardWinUser(),
    };
    public actions = {
        async getAll(context: ActionContext<AwardWinUserState, any>, payload: any) {
            context.state.loading = true;
            const reponse = await Ajax.get('/api/services/app/AwardWinUser/GetAwardWinUsers', {params: payload.data});
            context.state.loading = false;
            const page = reponse.data.result as PageResult<AwardWinUser>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
    };
    public mutations = {
        setCurrentPage(state: AwardWinUserState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: AwardWinUserState, pagesize: number) {
            state.pageSize = pagesize;
        },
    };
}
const awardWinUserModule = new AwardWinUserModule();
export default awardWinUserModule;
